import { useEffect } from "react";

export default function UpdateChecker() {
    useEffect(() => {
        const currentVersion = document.querySelector('meta[name="app-version"]')?.getAttribute('content');
        if (localStorage.getItem('appVersion') !== currentVersion) {
            localStorage.setItem('appVersion', currentVersion ?? '');
            window.location.reload();
        }
    }, []);

    return null;
}